import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import IconMenu from "../../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import {
  Routes,
  Route,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BasicTable from "../../../components/InfoDisplay/InfoDisplay";
import useSave from "../../../Hooks/useSave";
import Packaging from "./Packaging";
import Finishing from "./Finishing";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const menuHeader = {
  icon: <AssignmentIcon sx={{ color: "white" }} fontSize="small" />,
  name: "Chocolate Ru...",
};

const fColumns = [
  {
    id: "pc",
    name: "finishing",
  },
];

const fRows = [{ pc: "ch" }, { pc: "ch" }];

export default function Product() {
  const { fetchGraphql, DialogSave } = useSave();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  // useEffect(() => console.log(location), [location]);

  const bpColumns = [
    {
      id: "productCode",
      name: "Product code",
      edit: true,
    },
    {
      id: "productName",
      name: "Product name",
      edit: true,
    },
    {
      id: "productDescription",
      name: "Product Description",
      edit: true,
    },
    {
      id: "productUnitOfMeasure",
      name: "Bakery Unit Of Messure",
      edit: true,
    },
  ];

  const [bpRows, setBpRows] = useState([
    {
      productCode: "ch",
      productName: "chocolate Rugalech",
      productDescription: "",
      productUnitOfMessure: "Sheet",
    },
  ]);

  const menu = [
    {
      link: "base-product",
      state: {
        lastLocation: location?.state?.lastLocation,
        currentPage: location?.state?.currentPage,
        searchText: location?.state?.searchText,
      },
      name: "Base Product",
    },
    {
      link: "packaging",
      state: {
        lastLocation: location?.state?.lastLocation,
        currentPage: location?.state?.currentPage,
        searchText: location?.state?.searchText,
      },
      name: "Pakaging",
    },
    {
      link: "finishing",
      state: {
        lastLocation: location?.state?.lastLocation,
        currentPage: location?.state?.currentPage,
        searchText: location?.state?.searchText,
      },
      name: "Finishing",
    },
    {
      link: "rules",
      state: {
        lastLocation: location?.state?.lastLocation,
        currentPage: location?.state?.currentPage,
        searchText: location?.state?.searchText,
      },
      name: "Rules",
    },
  ];

  useEffect(() => {
    fetchGraphql({
      query: `query Products($productId: ID) {
        product(productId: $productId) {
          productCode
          productName
          productDescription
          productUnitOfMeasure
        }
      }`,
      variables: { productId: id },
    }).then((result) => {
      setBpRows([result.data.product]);
    });
  }, [location]);

  const bpOptions = {
    handleEdit: (e, row, columnId, index) => {
      setBpRows((rows) => {
        const copyState = [...rows];

        copyState[index][columnId] = e.target.value;

        return copyState;
      });
    },
    handleDontSave: (originalRow, index) => {
      setBpRows((rows) => {
        const copyState = [...rows];

        copyState[index] = originalRow;

        return copyState;
      });
    },
    handleSave: (index, row) => {
      fetchGraphql({
        query: `mutation UpdateProduct($productId: ID, $product: ProductInput) {
            updateProduct(productId: $productId, product: $product)
        }`,
        variables: { productId: id, product: bpRows[0] },
      });
    },
  };

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "row",
        width: "100%",
        overflow: "hidden",
      }}
    ><DialogSave/>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Button
          sx={{ margin: "0px auto 20px 0px", marginRight: "auto" }}
          variant="outlined"
          onClick={() =>
            navigate(location.state.lastLocation, {
              state: {
                currentPage: location.state.currentPage,
                searchText: location.state.searchText,
              },
            })
          }
        >
          <ArrowBackIcon />
          Back
        </Button>

        <IconMenu menuHeader={menuHeader} menu={menu} />
      </Box>

      <Paper
        sx={{
          width: "100%",
          height: "auto",
          marginLeft: "20px",
          padding: "20px",
          overflow: "auto",
          // display: "flex",
          // flexDirection: "column"
        }}
      >
        <Routes>
          <Route
            path="/base-product"
            element={
              <BasicTable
                columns={bpColumns}
                key="1"
                rows={bpRows}
                header="Base Product"
                options={bpOptions}
              />
            }
          />
          <Route path="/packaging" element={<Packaging />} />
          <Route path="/finishing" element={<Finishing />} />
          <Route
            path="/rules"
            element={
              <BasicTable
                key="4"
                columns={fColumns}
                rows={fRows}
                header="Rules"
              />
            }
          />
        </Routes>
      </Paper>
    </Box>
  );
}
